export function careerSlider() {
    let $sliderWrap = $(".career-slider-wrap");

    if ($sliderWrap.length) {
        let $curSlider = $sliderWrap.find(".career-slider");
        let slidesLength = $curSlider.find(".career-item").length;
        let $navContainer = $sliderWrap.find(".career-slider-nav");

        if (slidesLength > 1) {
            $curSlider.slick({
                infinite: false,
                dots: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                appendDots: $navContainer,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/careerSlider.js